<div class="header">
  <svg-icon icon="logo" size='largest' class="header__icon" (click)="navigateHome()"></svg-icon>
  <!-- menu shown only if the user is logged in and has roles -->
  @if (user() && user()?.roles?.length) {
  <button (click)="openNav()" mat-button class="header__menu-button">
    <div class="header__menu">
      <i class="material-icons">reorder</i>
      <span class="header__menu-label">{{labels.services}}</span>
    </div>
  </button>
  }
  @else {
    <div></div>
  }

  @if (user()) {
  <div class="header__user">
    @if (regionIcon) {
      <img class="header__skyicon" [src]="regionIcon.asset" alt="Logo" >
    }
    <button #userMenuButton="matMenuTrigger" mdbDropdownToggle [matMenuTriggerFor]="menu" class="header__button"
      [class.header__button_active]="menuOpen">
        <svg-icon icon="user" size="fill" class="header__user-icon"></svg-icon>
      <span class="header__user-name header__user-name--uppercase">{{user()?.userName}}</span>
    </button>
    <mat-menu #menu="matMenu" class="dropdown" backdropClass="dropdown-fullwidth">
      <div [style.width.px]="userMenuButtonWidth">
        <button mat-menu-item class="header__dropdown-item" (click)="logout()">{{labels.logOut}}</button>
      </div>
    </mat-menu>
  </div>
  }
  @else {
  <!--
  <div class="header__user">
    <button (click)="login()" class="header__button">
      <svg-icon icon="user" size="fill" class="header__user-icon"></svg-icon>
      <span class="header__user-name header__user-name--uppercase">{{labels.logIn}}</span>
    </button>
  </div>
  -->
  }

</div>

